import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const PROJECTS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    CONTRACTS: '/admin/contracts/',
    CONTRACT_DETAIL: (id: number) => `/admin/contracts/${id}/`,
    CONTRACT_ORDERS_BULK: (contractId: number) => `/admin/contracts/${contractId}/orders/bulk/`,
    PROJECT_STATUS_CHOICES: '/admin/project-status-choices-list',
  }),
} as const;
